module.exports = __webpack_public_path__ + "b3ad625633ccee8b27a36e0c843f2b2a.svg";